import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isStaff, isAdmin } from '@/lib/types';

/** Gate for authenticated staff (admin or moderator, not banned). */
export function ProtectedRoute() {
  const { user } = useAuth();
  if (!isStaff(user)) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}

/** Gate for admins only (used for user management + settings). */
export function AdminOnlyRoute() {
  const { user } = useAuth();
  if (!isStaff(user)) return <Navigate to="/admin/login" replace />;
  if (!isAdmin(user)) return <Navigate to="/admin" replace />;
  return <Outlet />;
}
